import React from 'react';
import { OrderingSelectors, OrderingConstants } from 'polygon-ordering';
import getDeviceTypeMobile from '../selectors/getDeviceTypeMobile';
import getExtremelyShortScreen from '../selectors/getExtremelyShortScreen';
import getOrderInProgress from '../selectors/getOrderInProgress';
import { COMPLETED_ORDER_SCREEN_ROUTE, INITIAL_SCREEN_ROUTE } from '../hooks/useRoutes';
import ScreenHero from '../components/ScreenHero';
import ScreenFloating from '../components/ScreenFloating';
import RedirectAndPreserveSearch from '../components/RedirectAndPreserveSearch';
import { useAppSelector } from '../app/hooks';
import StripeProvider from '../components/StripeProvider';
import { TyroProvider } from '../hooks/TyroProvider';
import { RedcatPaymentProvider } from '../shared/redcatpayments';
import ReviewOrderScreen from './ReviewOrderScreen';

const { getOrderSubmitted, getGatewayType } = OrderingSelectors;
const { PAYMENT_GATEWAY_TYPES } = OrderingConstants;

const ReviewOrderScreenWrapper = () => {
  const deviceTypeMobile = useAppSelector(getDeviceTypeMobile);
  const orderInProgress = useAppSelector(getOrderInProgress);
  const orderSubmitted = useAppSelector(getOrderSubmitted);
  const extremelyShortScreen = useAppSelector(getExtremelyShortScreen);
  const gatewayType = useAppSelector(getGatewayType);
  const checkoutInProgress = useAppSelector(state => state.checkoutInProgress);

  const useMobileScreen = deviceTypeMobile || extremelyShortScreen;

  const ScreenComponent = useMobileScreen || extremelyShortScreen ? ScreenHero : ScreenFloating;

  if (orderSubmitted && !checkoutInProgress) {
    return <RedirectAndPreserveSearch to={COMPLETED_ORDER_SCREEN_ROUTE} />;
  }

  if (!orderInProgress) {
    return <RedirectAndPreserveSearch to={INITIAL_SCREEN_ROUTE} />;
  }

  let PaymentProviderWrapper;

  if (gatewayType === PAYMENT_GATEWAY_TYPES.STRIPE) {
    PaymentProviderWrapper = StripeProvider;
  } else if (gatewayType === PAYMENT_GATEWAY_TYPES.TYRO) {
    PaymentProviderWrapper = TyroProvider;
  } else if (gatewayType === PAYMENT_GATEWAY_TYPES.REDCAT_PAY) {
    PaymentProviderWrapper = RedcatPaymentProvider;
  }

  return PaymentProviderWrapper ? (
    <PaymentProviderWrapper
      {...(gatewayType === PAYMENT_GATEWAY_TYPES.TYRO ? { route: 'checkout' } : {})}
      {...(gatewayType === PAYMENT_GATEWAY_TYPES.REDCAT_PAY
        ? { purchaseType: 'order' as const }
        : {})}
    >
      <ScreenComponent parentContainerStyle={useMobileScreen ? {} : styles.desktopParentContainer}>
        <ReviewOrderScreen />
      </ScreenComponent>
    </PaymentProviderWrapper>
  ) : (
    <ScreenComponent parentContainerStyle={useMobileScreen ? {} : styles.desktopParentContainer}>
      <ReviewOrderScreen />
    </ScreenComponent>
  );
};

const styles: Styles = {
  desktopParentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
};

export default ReviewOrderScreenWrapper;
